// breakPoints const
export const MIN_WIDTH_1400PX = '(min-width: 1400px)';
export const MAX_WIDTH_1399PX = '(max-width: 1399.98px)';
export const MIN_WIDTH_1025PX = '(min-width: 1025px)';
export const MAX_WIDTH_1024PX = '(max-width: 1024.98px)';
export const MIN_WIDTH_768PX = '(max-width: 768px)';
export const MAX_WIDTH_767PX = '(max-width: 767.98px)';

// layouts const
export const VERTICAL = 'vertical';
export const HORIZONTAL = 'horizontal';
export const COMPACT = 'compact';

// RTL constants
export const RTL = 'rtl';
export const LTR = 'ltr';

// DARK Const
export const LIGHT = 'light';
export const DARK = 'dark';
